<template>
		<div class="md-modal md-effect-4" :class="show?'md-show':''" id="modal-11">
			<div class="md-content">
				<h3>Our Storys</h3>
				<div>
					<p>Fragments in three years</p>
					<ul>
						<li @click="() => { onEvent(1) }">Encounter & Fate</li>
						<li @click="() => { onEvent(2) }">Today after three years</li>
						<li @click="() => { onEvent(3) }">What I want to say？</li>
						<li @click="() => { onEvent(4) }">How many days did we meet?</li>
					</ul>
					<button class="md-close" @click="() => { onEvent(0) }">Start</button>
				</div>
			</div>
		</div>
</template>

<script>
export default {
    props: {
        onEvent: {
            type: Function,
            default: () => {}
        },
    },
    data() {
        return {
            show: false
        }
    },
    mounted() {
        setTimeout(() => {
            this.show = true
        }, 1000);
    }
}
</script>

<style scoped>
@import url(./ModalEff.css);

a, button {
	outline: none;
}

a {
	color: #c0392b;
	text-decoration: none;
}

a:hover,
a:active {
	color: #333;
}

ul li {
	text-decoration: underline;
	cursor: pointer;
}

/* Header Style */
.main,
.container > header {
	margin: 0 auto;
	padding: 2em;
}

.container > header {
	text-align: center;
	background: #d94839;
	padding: 3em;
}

.container > header h1 {
	font-size: 2.625em;
	line-height: 1.3;
	margin: 0;
	font-weight: 300;
}

.container > header span {
	display: block;
	font-size: 60%;
	opacity: 0.7;
	padding: 0 0 0.6em 0.1em;
}

/* Main Content */
.main {
	max-width: 69em;
}

.column {
	float: left;
	width: 50%;
	padding: 0 2em;
	min-height: 300px;
	position: relative;
}

.column:nth-child(2) {
	box-shadow: -1px 0 0 rgba(0,0,0,0.1);
}

.column p {
	font-weight: 300;
	font-size: 2em;
	padding: 0;
	margin: 0;
	text-align: right;
	line-height: 1.5;
}

/* To Navigation Style */
.codrops-top {
	background: #fff;
	background: rgba(255, 255, 255, 0.2);
	text-transform: uppercase;
	width: 100%;
	font-size: 0.69em;
	line-height: 2.2;
}

.codrops-top a {
	padding: 0 1em;
	letter-spacing: 0.1em;
	display: inline-block;
}

.codrops-top a:hover {
	color: #e74c3c;
	background: rgba(255,255,255,0.6);
}

.codrops-top span.right {
	float: right;
}

.codrops-top span.right a {
	float: left;
	display: block;
}

.codrops-icon:before {
	font-family: 'codropsicons';
	margin: 0 4px;
	speak: none;
	font-style: normal;
	font-weight: normal;
	font-variant: normal;
	text-transform: none;
	line-height: 1;
	-webkit-font-smoothing: antialiased;
}

.codrops-icon-drop:before {
	content: "\e001";
}

.codrops-icon-prev:before {
	content: "\e004";
}

button {
	border: none;
	padding: 0.6em 1.2em;
	background: #c0392b;
	color: #fff;
	font-family: 'Lato', Calibri, Arial, sans-serif;
	font-size: 1em;
	letter-spacing: 1px;
	text-transform: uppercase;
	cursor: pointer;
	display: inline-block;
	margin: 3px 2px;
	border-radius: 2px;
}

button:hover {
	background: #A5281B;
}
</style>



// WEBPACK FOOTER //
// src/components/director/Alert.vue